export const set = (
  name: string,
  value: string,
  expires: number = null,
  secure: boolean = false,
  samesite: null | 'lax' | 'strict' = 'strict'
) => {
  if(!document || !document.cookie) return

  let cookie = name + '=' + value
  if(expires) cookie += ';expires=' + new Date(Date.now() + expires).toUTCString()
  if(secure) cookie += ';secure'
  if(samesite) cookie += ';samesite=' + samesite

  document.cookie = cookie
}

export const get = (name: string = null) => {
  if(!document || !document.cookie) return

  const cookies = document.cookie.split(';').map(
    (item) => item.split('=')
  ).reduce((acc: { [name: string]: string }, [k, v]) => {
    acc[k.trim()] = v.trim()
    return acc
  }, {})

  return name ? cookies[name] : cookies
}

export const remove = (name: string) => {
  if(!document || !document.cookie) return

  set(name, null, -1)
}
